import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import SearchBar from './search-bar';

function SearchResults(props) {
  const { query } = props.match.params;
  console.log(props.pages);

  return (
    <div id="search-results">
      <SearchBar className="search-bar" query={query} />
      <h2 id="results-indicator">{String(props.pages?.length) || '0'} results for &lsquo;{query}&rsquo;</h2>
      <div className="pages-listing-container">
        {props.pages.map((page) => {
          return (
            <NavLink className="pages-link"
              key={page.id}
              to={`/books/${page.Chapter.Book.id}/chapters/${page.Chapter.id}/pages/${page.id}`}
            >
              <div className="pages-listing-item" key={page.id}>
                <div className="pages-listing fold fold-beige">
                  <h2>{page.title}</h2>
                  <p>in <span id="italic"> {page.Chapter?.Book?.title}</span></p>
                </div>
              </div>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}

// ``

const mapStateToProps = (state) => (
  {
    pages: state.pages.all,
  }
);

export default withRouter(connect(mapStateToProps, null)(SearchResults));
